export default {
    /**
     * The offset at which grid columns start in the day/week view
     */
    ColumnOffset: 70,

    /**
     * Height of a row (one hour) in the calendar surface day/week view
     */
    HourRowHeight: 60,

    /**
     * Scrollbar width
     */
    ScrollbarWidth: 18,

    /**
     * Height in pixels of an all day row/item
     */
    AllDayRowHeight: 30,

    /**
     * The default duration for an appointment/meeting. TODO: Should be replaced with a setting from config
     */
    DefaultDurationInMinutes: 30,

    /**
     * Height in pixels of an item in month view
     */
    MonthItemHeight: 23,

    /**
     * Row height in the month grid
     */
    MonthRowHeight: 24,

    /**
     * Height of the day header label for a given day cell in month view
     */
    DayCellHeaderHeight: 36,

    /**
     * Offset for calculating scroll position when scrolling to working hours
     */
    scrollTopAdjustment: 10,

    /**
     * Subject line height
     */
    subjectLineHeight: 16,

    /**
     * Details line height
     */
    detailsLineHeight: 16,

    /**
     * The minimum month height before scaling is neccessary
     */
    minimumScalableMonthHeight: 270,

    /**
     * The default width of the timestrip
     */
    timeStripDefaultWidth: 60,

    /**
     * The minimum width of the print preview pane
     */
    printPreviewMinPaneWidth: 732,

    /**
     * The default width of the expanded left pane
     */
    leftPaneDefaultWidth: 228,

    /**
     * The minimum width of the expanded left pane
     */
    leftPaneMinWidthWithWeekNumbers: 244,

    /**
     * The minimum width of the expanded left pane
     */
    leftPaneMinWidthWithoutWeekNumbers: 228,

    /**
     * The maximum width of the expanded left pane
     */
    leftPaneMaxWidth: 320,

    /**
     * The static width of the left rail (collapsed left pane)
     */
    leftRailStaticWidth: 48,
};
